import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import RemoveIcon from "@mui/icons-material/Remove";
import ConveniosService from "../services/ConveniosService";
import ListasPreciosService from "../services/ListasPreciosService";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import Swal from "sweetalert2";
import { mostrarToast } from "../utils/toastUtils";
import ContactosService from "../services/ContactosService";
import { tieneMasDe10Digitos } from "../utils/telefonoUtils";

const Convenios = () => {
  useEffect(() => {
    document.title = "Convenios";
    fetchListas();
  }, []);

  function mostrarMensaje(mensaje) {
    mostrarToast(mensaje, "success");
    if (typeof fetchListas === "function") {
      fetchListas();
    }
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  async function mostrarBuscarConvenio() {
    let convenioOriginal = [];
    let convenioActivas = [];

    const ordenarConveniosRecientes = (lista) => {
      if (!Array.isArray(lista)) return [];
      return [...lista].sort(
        (a, b) => Number(b.idConvenio || b.id || 0) - Number(a.idConvenio || a.id || 0),
      );
    };

    const resultado = await ConveniosService.getConvenios();
    convenioOriginal = ordenarConveniosRecientes(resultado?.data?.convenios || resultado?.convenios || []);
    convenioActivas = [...convenioOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (lista) => {
      return lista
        .map(
          (comp, idx) => `
      <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
        <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${comp.nombre}</td>
        <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
          <button data-action="mostrar" data-idconvenio="${comp.idConvenio}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
            <i class="fas fa-eye"></i>
          </button>
        </td>
        <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
          <button data-action="editar" data-idconvenio="${comp.idConvenio}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
            <i class="fas fa-edit"></i>
          </button>
        </td>
        <td style="padding: 4px 6px; text-align: center;">
          <button data-action="eliminar" data-idconvenio="${comp.idConvenio}" title="Eliminar" style="background: #fee2e2; color: #dc2626; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
    `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaConvenios = convenioActivas.slice(inicio, fin);
      const tabla = document.getElementById("tablaCompanias");
      if (tabla) {
        if (!paginaConvenios || paginaConvenios.length === 0) {
          tabla.innerHTML = `<tr><td colspan="4" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaConvenios);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idconvenio;
              const convenio = convenioOriginal.find(
                (item) => String(item.idConvenio) === String(id),
              );
              if (convenio) {
                verConvenio(convenio);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idconvenio;
              const convenio = convenioOriginal.find(
                (item) => String(item.idConvenio) === String(id),
              );
              if (convenio) {
                editarConvenio(convenio);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='eliminar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idconvenio;
              const convenio = convenioOriginal.find(
                (item) => String(item.idConvenio) === String(id),
              );
              if (convenio) {
                Swal.fire({
                  title: "¿Eliminar convenio?",
                  text: `¿Desea eliminar el convenio ${convenio.nombre}?`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sí, eliminar",
                  cancelButtonText: "Cancelar",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    await eliminarConvenio(convenio.idConvenio);
                  }
                });
              }
            });
          });
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(convenioActivas.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${convenioActivas.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR CONVENIO",
      width: "60%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
      <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
        <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
          <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px;">
            <label style="font-size: 0.80rem; font-weight: 600; color: #334155;">Nombre de la compañía:</label>
            <input id="buscarCompania" type="text" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="Escribe aquí...">
          </div>
          <div>
            <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
              Mostrar todas las compañías
            </button>
          </div>
        </div>

        <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
          <table class="tablaCompanias" style="width: 100%; border-collapse: collapse; text-align: center;">
            <thead>
              <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Empresa</th>
                <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Editar</th>
                <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Eliminar</th>
              </tr>
            </thead>
            <tbody id="tablaCompanias">
            </tbody>
          </table>
        </div>

        <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
          <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
          <div style="display: flex; gap: 6px;">
            <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
            <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
          </div>
        </div>
      </div>
    `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (paginaActual < Math.ceil(convenioActivas.length / porPagina)) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await ConveniosService.getConvenios();
              convenioOriginal = ordenarConveniosRecientes(resultado?.data?.convenios || resultado?.convenios || []);
              convenioActivas = [...convenioOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar convenios:", error);
            }
            document.getElementById("buscarCompania").value = "";
          });
        document
          .getElementById("buscarCompania")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              convenioActivas = [...convenioOriginal];
              renderPagina(paginaActual);
              return;
            }

            try {
              const resultado = await ConveniosService.buscarConvenios(valor);
              convenioActivas = ordenarConveniosRecientes(resultado?.convenios || resultado?.data?.convenios || []);
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error en búsqueda:", error);
            }
          });
      },
    });
  }

  function reloadPage() {
    window.location.reload();
  }

  const [nombre, setNombre] = useState("");
  const [giro, setGiro] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [estado, setEstado] = useState("seleccione");
  const [estadoF, setEstadoF] = useState("seleccione");
  const [ciudad, setCiudad] = useState("");
  const [ciudadF, setCiudadF] = useState("");
  const [direccion, setDireccion] = useState("");
  const [direccionF, setDireccionF] = useState("");
  const [colonia, setColonia] = useState("");
  const [coloniaF, setColoniaF] = useState("");
  const [cPostal, setCPostal] = useState("");
  const [cPostalF, setCPostalF] = useState("");
  const [rfc, setRfc] = useState("");
  const [razonS, setRazonS] = useState("");
  const [datosF, setDatosF] = useState("seleccione");
  const [contactos, setContactos] = useState([
    {
      tipo: "",
      nombre: "",
      telefono: "",
      correo: "",
      notas: "",
    },
  ]);
  const handleChangeContacto = (index, field, value) => {
    const nuevosContactos = [...contactos];
    nuevosContactos[index] = {
      ...nuevosContactos[index],
      [field]: value,
    };
    setContactos(nuevosContactos);
  };

  const handleAddContacto = () => {
    setContactos([
      ...contactos,
      {
        tipo: "",
        nombre: "",
        telefono: "",
        correo: "",
        notas: "",
      },
    ]);
  };

  const handleRemoveContacto = (index) => {
    const nuevosContactos = contactos.filter((_, i) => i !== index);
    setContactos(nuevosContactos);
  };

  const eliminarConvenio = async (convenioId) => {
    try {
      const resultado = await ConveniosService.deleteConvenio(convenioId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Convenio eliminado con éxito!");
      } else {
        mostrarError("Error al eliminar convenio");
      }
    } catch (error) {
      console.error("Error al eliminar convenio:", error);
      mostrarError("Error al eliminar convenio");
    }
  };

  const [listaPrecios, setListaPrecios] = useState("");
  const [listasPrecios, setListasPrecios] = useState([]);
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorListaPrecios, setErrorListaPrecios] = useState(false);
  const [selectedConvenioId, setSelectedConvenioId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  const verConvenio = async (convenio) => {
    setNombre(convenio.nombre || "");
    setGiro(convenio.giro || "");
    setTelefono(convenio.telefono || "");
    setEmail1(convenio.email1 || "");
    setEmail2(convenio.email2 || "");
    setEstado(convenio.estado || "seleccione");
    setCiudad(convenio.ciudad || "");
    setDireccion(convenio.direccion || "");
    setColonia(convenio.colonia || "");
    setCPostal(convenio.cPostal || "");
    setRfc(convenio.rfc || "");
    setRazonS(convenio.razonS || "");
    setEstadoF(convenio.estadoFiscal || "");
    setCiudadF(convenio.ciudadFiscal || "");
    setDireccionF(convenio.direccionFiscal || "");
    setColoniaF(convenio.coloniaFiscal || "");
    setCPostalF(convenio.cPostalFiscal || "");
    setListaPrecios(convenio.idListaPrecio);
    try {
      const resultado = await ContactosService.getContactosPorConvenio(
        convenio.idConvenio,
      );
      setContactos(resultado.data?.contactos || []);
    } catch (error) {
      console.error(error);
      setContactos([]);
    }
    setSelectedConvenioId(null);
    setEditMode(false);
    setViewOnly(true);
  };

  const editarConvenio = async (convenio) => {
    setNombre(convenio.nombre || "");
    setGiro(convenio.giro || "");
    setTelefono(convenio.telefono || "");
    setEmail1(convenio.email1 || "");
    setEmail2(convenio.email2 || "");
    setEstado(convenio.estado || "seleccione");
    setCiudad(convenio.ciudad || "");
    setDireccion(convenio.direccion || "");
    setColonia(convenio.colonia || "");
    setCPostal(convenio.cPostal || "");
    setRfc(convenio.rfc || "");
    setRazonS(convenio.razonS || "");
    setEstadoF(convenio.estadoFiscal || "");
    setCiudadF(convenio.ciudadFiscal || "");
    setDireccionF(convenio.direccionFiscal || "");
    setColoniaF(convenio.coloniaFiscal || "");
    setCPostalF(convenio.cPostalFiscal || "");
    setListaPrecios(convenio.idListaPrecio);
    try {
      const resultado = await ContactosService.getContactosPorConvenio(
        convenio.idConvenio,
      );
      setContactos(resultado.contactos || []);
    } catch (error) {
      console.error(error);
      setContactos([]);
    }
    setSelectedConvenioId(convenio.idConvenio);
    setEditMode(true);
    setViewOnly(false);
  };

  async function fetchListas() {
    try {
      const resultado = await ListasPreciosService.getListas();
      const data = resultado.data.listas;
      setListasPrecios(data);
    } catch (err) {
      console.error(err);
    }
  }

  const agregarConvenio = async () => {
    if (nombre === "" && listaPrecios === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
      setErrorListaPrecios(true);
    } else if (nombre === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
    } else if (listaPrecios === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorListaPrecios(true);
    } else if (tieneMasDe10Digitos(telefono)) {
      mostrarError("El teléfono de la empresa no puede tener más de 10 dígitos.");
    } else if (contactos && contactos.some(c => tieneMasDe10Digitos(c.telefono))) {
      mostrarError("El teléfono de los contactos no puede tener más de 10 dígitos.");
    } else {
      let convenio;
      let convenioUpd;
      let resultado = {};
      if (editMode) {
        resultado.existe = false;
      } else {
        resultado = await ConveniosService.validarCompania(nombre);
      }

      if (resultado.existe === true && !editMode) {
        mostrarError(resultado.mensaje);
      } else {
        let compEstado;
        if (datosF === "si") {
          if (estado === "seleccione") {
            compEstado = "";
          } else {
            compEstado = estado;
          }
          convenio = {
            compania: {
              nombre: nombre,
              giro: giro,
              telefono: telefono,
              email1: email1,
              email2: email2,
              estatus: "A",
              estado: compEstado,
              ciudad: ciudad,
              direccion: direccion,
              colonia: colonia,
              cPostal: cPostal,
              rfc: rfc,
              razonS: razonS,
              estadoFiscal: estado,
              ciudadFiscal: ciudad,
              direccionFiscal: direccion,
              coloniaFiscal: colonia,
              cPostalFiscal: cPostal,
              idListaPrecio: listaPrecios,
            },
            contactos: contactos,
          };

          convenioUpd = {
            compania: {
              nombreN: nombre,
              giroN: giro,
              telefonoN: telefono,
              email1N: email1,
              email2N: email2,
              estatusN: "A",
              estadoN: compEstado,
              ciudadN: ciudad,
              direccionN: direccion,
              coloniaN: colonia,
              cPostalN: cPostal,
              rfcN: rfc,
              razonSN: razonS,
              estadoFiscalN: estado,
              ciudadFiscalN: ciudad,
              direccionFiscalN: direccion,
              coloniaFiscalN: colonia,
              cPostalFiscalN: cPostal,
              idListaPrecioN: listaPrecios,
            },
            contactosN: contactos,
          };
        } else {
          let compEstadoF;
          if (estado === "seleccione") {
            compEstado = "";
          } else {
            compEstado = estado;
          }
          if (estadoF === "seleccione") {
            compEstadoF = "";
          } else {
            compEstadoF = estadoF;
          }
          convenio = {
            compania: {
              nombre: nombre,
              giro: giro,
              telefono: telefono,
              email1: email1,
              email2: email2,
              estatus: "A",
              estado: compEstado,
              ciudad: ciudad,
              direccion: direccion,
              colonia: colonia,
              cPostal: cPostal,
              rfc: rfc,
              razonS: razonS,
              estadoFiscal: compEstadoF,
              ciudadFiscal: ciudadF,
              direccionFiscal: direccionF,
              coloniaFiscal: coloniaF,
              cPostalFiscal: cPostalF,
              idListaPrecio: listaPrecios,
            },
            contactos: contactos,
          };

          convenioUpd = {
            compania: {
              nombreN: nombre,
              giroN: giro,
              telefonoN: telefono,
              email1N: email1,
              email2N: email2,
              estatusN: "A",
              estadoN: compEstado,
              ciudadN: ciudad,
              direccionN: direccion,
              coloniaN: colonia,
              cPostalN: cPostal,
              rfcN: rfc,
              razonSN: razonS,
              estadoFiscalN: compEstadoF,
              ciudadFiscalN: ciudadF,
              direccionFiscalN: direccionF,
              coloniaFiscalN: coloniaF,
              cPostalFiscalN: cPostalF,
              idListaPrecioN: listaPrecios,
            },
            contactosN: contactos,
          };
        }
        try {
          let resultado;
          if (editMode && selectedConvenioId) {

            resultado = await ConveniosService.updateConvenio(
              convenioUpd,
              selectedConvenioId,
            );
          } else {

            resultado = await ConveniosService.agregarConvenio(convenio);
          }

          if (resultado.data.estatus === "OK") {
            mostrarMensaje(
              editMode
                ? "Convenio actualizado con éxito!"
                : "Convenio agregado con exito!",
            );
          } else {
            mostrarError(
              editMode
                ? "No se pudo actualizar el convenio: " + resultado.data.mensaje
                : "No se pudo agregar el convenio: " + resultado.data.mensaje,
            );
          }
        } catch (error) {
          mostrarError(
            editMode
              ? "Error al actualizar convenio:"
              : "Error al agregar convenio:",
            error,
          );
        }
      }
    }
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperConv"
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h7"
                  fontWeight="bold"
                  gutterBottom
                  align="center"
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 1vw",
                    borderRadius: "8px",
                    display: "inline-block",
                    marginTop: "0vw",
                    fontWeight: "bold"
                  }}
                >
                  DATOS DE LA COMPAÑIA
                </Typography>
              </Box>
              {/* Contenedor principal */}

              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfNombre"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Nombre:<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={nombre}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setNombre(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfNombre"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfGiro"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Giro:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={giro}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setGiro(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfGiro"
                      required
                    />
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={4}>
                    <InputLabel
                      htmlFor="txfTelefono"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Telefono:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={telefono}
                      disabled={viewOnly}
                      error={tieneMasDe10Digitos(telefono)}
                      helperText={tieneMasDe10Digitos(telefono) ? "Máximo 10 dígitos" : ""}
                      onChange={(e) => {
                        setTelefono(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfTelefono"
                      required
                    />
                  </Grid>

                  {/* Fecha de nacimiento */}
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfEmail1"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Email 1:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={email1}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setEmail1(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "14.5vw",
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfEmail1"
                      type="email"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  {/* Email y teléfonos */}
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfEmail2"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Email 2:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={email2}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setEmail2(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfEmail2"
                      type="email"
                    />
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="selectEstado"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Estado:
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={estado}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setEstado(e.target.value);
                      }}
                      sx={{
                        flex: "0 0 8vw",
                        width: "14.6vw",
                        maxWidth: "100%",

                        height: "5vh",
                        minHeight: "0px !important",
                        overflow: "hidden",

                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },

                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },

                        "& .MuiOutlinedInput-notchedOutline": {
                          top: 0,
                          "& legend": { display: "none" },
                        },

                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",
                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectEstado"
                    >
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="seleccione"
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Aguascalientes"
                      >
                        Aguascalientes
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Baja California"
                      >
                        Baja California
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Baja California Sur"
                      >
                        Baja California Sur
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Campeche"
                      >
                        Campeche
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Chiapas"
                      >
                        Chiapas
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Chihuahua"
                      >
                        Chihuahua
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Ciudad de México"
                      >
                        Ciudad de México
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Coahuila"
                      >
                        Coahuila
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Colima"
                      >
                        Colima
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Durango"
                      >
                        Durango
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Estado de México"
                      >
                        Estado de México
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Guanajuato"
                      >
                        Guanajuato
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Guerrero"
                      >
                        Guerrero
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Hidalgo"
                      >
                        Hidalgo
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Jalisco"
                      >
                        Jalisco
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Michoacán"
                      >
                        Michoacán
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Morelos"
                      >
                        Morelos
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Nayarit"
                      >
                        Nayarit
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Nuevo León"
                      >
                        Nuevo León
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Oaxaca"
                      >
                        Oaxaca
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Puebla"
                      >
                        Puebla
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Querétaro"
                      >
                        Querétaro
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Quintana Roo"
                      >
                        Quintana Roo
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="San Luis Potosí"
                      >
                        San Luis Potosí
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Sinaloa"
                      >
                        Sinaloa
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Sonora"
                      >
                        Sonora
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Tabasco"
                      >
                        Tabasco
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Tamaulipas"
                      >
                        Tamaulipas
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Tlaxcala"
                      >
                        Tlaxcala
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Veracruz"
                      >
                        Veracruz
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Yucatán"
                      >
                        Yucatán
                      </MenuItem>
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="Zacatecas"
                      >
                        Zacatecas
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfCiudad"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Ciudad/Delegacion/Municipio:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={ciudad}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCiudad(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "14.6vw",
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCiudad"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfDireccion"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                        ml: "0.5vw"
                      }}
                    >
                      Direccion:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={direccion}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setDireccion(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "14.6vw",
                          height: "5vh",
                          ml: "0.5vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfDireccion"
                    />
                  </Grid>

                  {/* Fecha de nacimiento */}
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfColonia"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Colonia:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={colonia}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setColonia(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "12.51vw",
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfColonia"
                    />
                  </Grid>
                  {/* Email y teléfonos */}
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfCPostal"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Codigo Postal:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={cPostal}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCPostal(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCPostal"
                    />
                  </Grid>
                </Stack>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperLugar"
            >
              {/* Lugar de atencion */}
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    align="center"
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "0vw",
                      fontWeight: "bold"
                    }}
                  >
                    DATOS DE FACTURACION
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"2vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfRfc"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      RFC:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={rfc}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setRfc(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfRfc"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfRazon"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Razon Social:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={razonS}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setRazonS(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfRazon"
                    />
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.6vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="selectDatosF"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      ¿Los datos proporcionados de direccion son los mismos que
                      de facturacion?:
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={datosF}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setDatosF(e.target.value);
                      }}
                      sx={{
                        width: "14.6vw",
                        maxWidth: "100%",

                        height: "5vh",
                        minHeight: "0px !important",
                        overflow: "hidden",

                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },

                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },

                        "& .MuiOutlinedInput-notchedOutline": {
                          top: 0,
                          "& legend": { display: "none" },
                        },

                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",
                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectDatosF"
                    >
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="seleccione"
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="si"
                      >
                        Si
                      </MenuItem>
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="no"
                      >
                        No
                      </MenuItem>
                    </Select>
                  </Grid>
                </Stack>
              </Grid>

              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.6vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="selectEstadoF"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Estado:
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={estadoF}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setEstadoF(e.target.value);
                      }}
                      sx={{
                        width: "14.6vw",
                        maxWidth: "100%",

                        height: "5vh",
                        minHeight: "0px !important",
                        overflow: "hidden",

                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },

                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },

                        "& .MuiOutlinedInput-notchedOutline": {
                          top: 0,
                          "& legend": { display: "none" },
                        },

                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",
                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectEstadoF"
                    >
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="seleccione"
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfCiudadF"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Ciudad/Delegacion/Municipio:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={ciudadF}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCiudadF(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "14.6vw",
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCiudadF"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfDireccionF"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Direccion:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={direccionF}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setDireccionF(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "12.51vw",
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfDireccionF"
                    />
                  </Grid>

                  {/* Fecha de nacimiento */}
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="txfColoniaF"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Colonia:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={coloniaF}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setColoniaF(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          width: "12.51vw",
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfColoniaF"
                    />
                  </Grid>
                  {/* Email y teléfonos */}
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfCPostalF"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Codigo Postal:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={cPostalF}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCPostalF(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCPostalF"
                    />
                  </Grid>
                </Stack>
              </Grid>
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperAcceso"
            >
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      fontWeight: "bold"
                    }}
                  >
                    DATOS DE CONTACTOS
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"2vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                {contactos.map((contacto, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1vw",
                      paddingTop: "0.4vw",
                      flexWrap: "wrap",
                    }}
                  >
                    <Grid item xs={6}>
                      {index === 0 && (
                        <InputLabel
                          htmlFor={`txfTipo${index}`}
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Tipo:
                        </InputLabel>
                      )}
                      <TextField
                        id={`txfTipo${index}`}
                        fullWidth
                        disabled={viewOnly}
                        value={contacto.tipo}
                        onChange={(e) =>
                          handleChangeContacto(index, "tipo", e.target.value)
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "10vw",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfTipo"
                      />
                    </Grid>

                    <Grid item xs={2}>
                      {index === 0 && (
                        <InputLabel
                          htmlFor={`txfNombre${index}`}
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Nombre:
                        </InputLabel>
                      )}
                      <TextField
                        id={`txfNombre${index}`}
                        fullWidth
                        disabled={viewOnly}
                        value={contacto.nombre}
                        onChange={(e) =>
                          handleChangeContacto(index, "nombre", e.target.value)
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "8vw",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfNombre"
                      />
                    </Grid>

                    <Grid item xs={2}>
                      {index === 0 && (
                        <InputLabel
                          htmlFor={`txfTelefono${index}`}
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Telefono:
                        </InputLabel>
                      )}
                      <TextField
                        id={`txfTelefono${index}`}
                        fullWidth
                        disabled={viewOnly}
                        value={contacto.telefono}
                        error={tieneMasDe10Digitos(contacto.telefono)}
                        helperText={tieneMasDe10Digitos(contacto.telefono) ? "Máximo 10 dígitos" : ""}
                        onChange={(e) =>
                          handleChangeContacto(
                            index,
                            "telefono",
                            e.target.value,
                          )
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfTelefono"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      {index === 0 && (
                        <InputLabel
                          htmlFor={`txfCorreo${index}`}
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Correo:
                        </InputLabel>
                      )}
                      <TextField
                        id={`txfCorreo${index}`}
                        fullWidth
                        disabled={viewOnly}
                        value={contacto.correo}
                        onChange={(e) =>
                          handleChangeContacto(index, "correo", e.target.value)
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfCorreo"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      {index === 0 && (
                        <InputLabel
                          htmlFor={`txfNotas${index}`}
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Notas:
                        </InputLabel>
                      )}
                      <TextField
                        id={`txfNotas${index}`}
                        multiline
                        minRows={1}
                        maxRows={4}
                        disabled={viewOnly}
                        value={contacto.notas}
                        onChange={(e) =>
                          handleChangeContacto(index, "notas", e.target.value)
                        }
                        sx={{
                          "& .MuiInputBase-root": {},
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfNotas"
                      />
                    </Grid>
                    {index > 0 && (
                      <IconButton
                        onClick={() => handleRemoveContacto(index)}
                        sx={{ color: "red", marginTop: "1.4vw" }}
                      >
                        <RemoveIcon />
                      </IconButton>
                    )}
                  </Box>
                ))}
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0.5vw",
                }}
              >
                <IconButton
                  onClick={handleAddContacto}
                  sx={{ color: "#006787" }}
                >
                  Añadir contacto
                  <AddIcon />
                </IconButton>
              </Box>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperLugar"
            >
              {/* Lugar de atencion */}
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    align="center"
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "0vw",
                      fontWeight: "bold"
                    }}
                  >
                    LISTA DE PRECIOS
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.4vw", justifyContent: "center" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="selectListaPrecios"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Lista de precios predeterminada:
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={listaPrecios || "seleccione"}
                      onChange={(e) => setListaPrecios(e.target.value)}
                      disabled={viewOnly}
                      sx={{
                        width: "20vw",
                        maxWidth: "100%",
                        height: "5vh",
                        minHeight: "0px !important",
                        overflow: "hidden",
                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },
                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          top: 0,
                          "& legend": { display: "none" },
                        },
                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",
                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectListasPrecio"
                    >
                      <MenuItem
                        sx={{ fontSize: "1vw", padding: "0.5vw" }}
                        value="seleccione"
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                      {listasPrecios.map((lista) => (
                        <MenuItem
                          key={lista.idListaPrecio}
                          value={lista.idListaPrecio}
                          sx={{
                            fontSize: "1vw",
                            padding: "0.5vw",
                          }}
                        >
                          {lista.nombre || "Lista de precio"}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Stack>
              </Grid>
            </Paper>
          </Stack>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar compañia"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <SaveIcon
                  onClick={agregarConvenio}
                  sx={{ fontSize: "1.8vw" }}
                />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={"Nueva compañia"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Buscar compañia"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={mostrarBuscarConvenio}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default Convenios;
